// useColorScheme from react-native does not support web currently. You can replace
// this with react-native-appearance if you would like theme support on web.
export default function useColorScheme() {
  // TODO: Eventually update to allow users to select their theme
  return 'dark';
}
